import { createListenerMiddleware } from "@reduxjs/toolkit";
import { restoreUserSettings } from "./persistence";
import { getTenant } from "app/getTenant";
import { loginUser, refreshToken } from "store/auth/authActions";

export const persistenceListener = createListenerMiddleware();

const restoreSettings = async (_, { getState, dispatch }) => {
  const { userInfo, settingsRestored } = getState().auth;
  const userId = userInfo?.userId;

  if (userId == null  || settingsRestored) return;

  await dispatch(restoreUserSettings(getTenant(), userId));
};

persistenceListener.startListening({
  matcher: (action) =>
    loginUser.fulfilled.match(action) ||
    refreshToken.fulfilled.match(action),
  effect: restoreSettings
});